import { createSelector } from 'reselect';

import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

const _selectData = (state) => {
    return state[SLICE_NAMESPACE][NAMESPACE];
};

const selectOriginInput = createSelector(
    _selectData,
    (stateSlice) => stateSlice.originInput,
);

const selectDestinationInput = createSelector(
    _selectData,
    (stateSlice) => stateSlice.destinationInput,
);

const selectOriginPlaceId = createSelector(
    _selectData,
    (stateSlice) => stateSlice.originPlaceId,
);

const selectDestinationPlaceId = createSelector(
    _selectData,
    (stateSlice) => stateSlice.destinationPlaceId,
);

export {
    selectDestinationInput,
    selectDestinationPlaceId,
    selectOriginInput,
    selectOriginPlaceId,
};
